/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResetPasswordSent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import BackToSignInAction from './BackToSignInAction/index'
import React from 'react'
import TysiaBrandLogo from 'DesignSystem/TysiaBrandLogo/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ResetPasswordSent({
  children,
  viewPath = "/App/Auth/ResetPasswordSent"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsWhite1 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white;'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="ResetPasswordSent.Vertical"
  data-view-path={viewPath}
 style={{'--bc-3-Z2g90JK': dtColorsWhite,'--o-1-Z2g90JK': isBefore ? 0 : 1,'--tx-2-Z2g90JK': isBefore ? "-32px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={isMedia.desktop}>
<div
  data-testid="ResetPasswordSent.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-Z2g90JK': dtColorsWhite1,'--pt-4-Z2g90JK': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pr-5-Z2g90JK': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pb-6-Z2g90JK': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pl-7-Z2g90JK': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ResetPasswordSent.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
/>
<TysiaBrandLogo
  viewPath={`${viewPath}/TysiaBrandLogo`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="The cloud-based orthodontist software that elevates your patients' experience without third-party addons."
 color={dtColorsWhite}
 fontSize="22px"
 lineHeight="32px"
/>
</div>
</fromFlow.When>
<div
  data-testid="ResetPasswordSent.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="ResetPasswordSent.Vertical:4"
  data-view-path={viewPath}
 style={{'--w-8-Z2g90JK': isMedia.mobile ? "340px" : "400px"}}
 className={`views-block ${styles.Vertical4}`}
>
<div
  data-testid="ResetPasswordSent.Vertical:5"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 marginTop={dtSpaceS}
 marginBottom={dtSpaceXxs}
 text="Check your email"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXs}
 color={dtColorsNeutral700}
 text="Click on the link in the email to reset your password. No email? Check your spam folder"
/>
</div>
<BackToSignInAction
  viewPath={`${viewPath}/BackToSignInAction`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}